import { Component } from "@angular/core";

@Component({
  selector: "corporate-questions-section",
  template: require('./corporate-questions-section.component.html'),
})
export class CorporateQuestionsSectionComponent {
  constructor() {}
}